import { apiRequest } from '../api';
import { PRODUCT } from '../endPoints';

export const GET_CATALOGUE = (catalogID) => {
  return apiRequest('get', PRODUCT.GET_CATALOGUE(catalogID));
};

export const GET_CATALOGUE_BY_METADATA_ID = (metadataid) => {
  return apiRequest('get', PRODUCT.GET_CATALOGUE_BY_METADATA_ID(metadataid));
};

export const POST_CONNECT_CATALOGUE_TO_METADATA = (metadataid, data) => {
  return apiRequest('post', PRODUCT.POST_CONNECT_CATALOGUE_TO_METADATA(metadataid), data);
};
export const DELETE_DISCONNECT_CATALOGUE_FROM_METADATA = (metadataid, data) => {
  return apiRequest('delete', PRODUCT.DELETE_DISCONNECT_CATALOGUE_FROM_METADATA(metadataid), data);
};

export const GET_PRODUCTS = (metadataId, cursor, search) => {
  let params = {
    after: cursor,
    limit: 30,
    search,
  };
  return apiRequest('get', PRODUCT.GET_PRODUCTS(metadataId), null, params);
};

export const POST_PRODUCTS = (metadataid, data) => {
  return apiRequest('post', PRODUCT.POST_PRODUCT(metadataid), data);
};
